<template>
    <article class="machine-list-row" role="button" tabindex="0" @click="$emit('open-item', item)"
        @keydown.enter="$emit('open-item', item)" @keydown.space.prevent="$emit('open-item', item)">
        <MachineModelImage :size="58" :relativePath="item && item.ModelImage" />
        <div class="machine-list-main">
            <h3>{{ machineTitle(item) }}</h3>
            <p>{{ machineSubtitle(item) }}</p>
            <div class="machine-list-meta">
                <span>{{ item.Name || "-" }}</span>
                <span>
                    <v-icon icon="mdi-barcode" size="15" />
                    {{ item.SerialNumber || "-" }}
                </span>
                <span>
                    <v-icon icon="mdi-qrcode" size="15" />
                    {{ item.Qrcode || "-" }}
                </span>
            </div>
        </div>
        <div class="machine-list-status">
            <span class="signal-chip service" :class="{ active: hasJobs(item.ActiveServiceJobs) }">
                <v-icon icon="mdi-briefcase-outline" size="15"></v-icon>
                {{ item.ActiveServiceJobs || 0 }}
            </span>
            <span class="signal-chip parts" :class="{ active: hasJobs(item.ActivePartsJobs) }">
                <v-icon icon="mdi-tag" size="15"></v-icon>
                {{ item.ActivePartsJobs || 0 }}
            </span>
        </div>
        <v-icon color="primary">mdi-chevron-right</v-icon>
    </article>
</template>


<script>
import MachineModelImage from "@/components/Cards/MachineModelImage.vue";

export default {
    name: "CustomerMachineRowItem",
    components: {
        MachineModelImage,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        machineTitle: {
            type: Function,
            required: true,
        },
        machineSubtitle: {
            type: Function,
            required: true,
        },
    },

    methods: {
        hasJobs(jobCount) {
            return Number(jobCount) > 0;
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang="scss" scoped>
.machine-list-row {

    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto auto;
    align-items: center;
    gap: 14px;
    margin: 4px 12px;
    padding: 12px 14px;
    border: 1px solid rgba(24, 39, 75, 0.1);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 8px 22px rgba(24, 39, 75, 0.08);
    cursor: pointer;
    transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;

    &:hover,
    &:focus-visible {
        border-color: rgba(30, 116, 92, 0.35);
        box-shadow: 0 12px 30px rgba(24, 39, 75, 0.14);
        outline: none;
        transform: translateY(-1px);
    }
}

.machine-list-main {
    min-width: 0;

    h3,
    p {
        overflow: hidden;
        margin: 0;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    h3 {
        color: rgba(25, 34, 46, 0.92);
        font-size: 15px;
        font-weight: 700;
    }

    p {
        margin-top: 4px;
        color: rgba(25, 34, 46, 0.58);
        font-size: 13px;
    }
}

.machine-list-meta,
.machine-list-status {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.machine-list-meta {
    margin-top: 7px;
    color: rgba(25, 34, 46, 0.56);
    font-size: 12px;

    span {
        min-width: 0;
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.signal-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 28px;
    min-width: 0;
    padding: 5px 8px;
    border-radius: 6px;
    background: #f4f6f8;
    color: rgba(25, 34, 46, 0.62);
    font-size: 12px;
    font-weight: 650;
    line-height: 1.2;
    white-space: nowrap;

    &.service.active {
        background: rgba(120, 86, 255, 0.11);
        color: #5a42b3;
    }

    &.parts.active {
        background: rgba(204, 75, 121, 0.12);
        color: #9a3158;
    }
}

@media (max-width: 720px) {
    .machine-list-row {
        grid-template-columns: auto minmax(0, 1fr) auto;
        gap: 10px;
        padding: 10px;
    }

    .machine-list-status {
        display: none;
    }
}
</style>
